import * as Icons from '@heroicons/react/24/outline'

export type IconName = keyof typeof Icons

export const IconNames: IconName[] = Object.keys(Icons) as IconName[]

export { Icons }
